var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBagOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.655 6.565v12.211H2.344V6.565zm-8.642-5.341A3.457 3.457 0 0 1 14.6 4.616v.726H7.4v-.726a3.472 3.472 0 0 1 3.613-3.392zm4.934 4.118v-.726A4.732 4.732 0 0 0 11.013 0a4.747 4.747 0 0 0-4.961 4.616v.726H2.624A1.463 1.463 0 0 0 1 6.752v11.866A1.379 1.379 0 0 0 2.624 20h16.913C20.668 20 21 19.388 21 18.618V6.752a1.37 1.37 0 0 0-1.463-1.41z",
    transform: "translate(-1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBagOutline);
export default __webpack_public_path__ + "static/media/icon-bag-outline.bdad026b.svg";
export { ForwardRef as ReactComponent };